import { render } from "./NavBtns.vue?vue&type=template&id=2ff04b4a"
import script from "./NavBtns.vue?vue&type=script&lang=js"
export * from "./NavBtns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__